import React, { useMemo } from 'react';
import { SelectProps } from '@material-ui/core/Select';
import { Select } from '../BoldInput';
import { fundingRequestType } from '../../../helpers/fundingRequestType';

interface FundingRequestTypeSelectProps extends SelectProps {
  setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void;
  withHeader: boolean;
  label: string;
  value: string;
  type: 'broker' | 'carrier' | undefined;
}

const FundingRequestTypeSelect = (
  props: FundingRequestTypeSelectProps
): JSX.Element => {
  const filteredOptions = useMemo(() => {
    if (!props.type) {
      return fundingRequestType;
    }

    let allowedOptions;
    if (props.type === 'carrier') {
      allowedOptions = fundingRequestType.filter(
        (option) =>
          option.value === 'STD_CARRIER' ||
          option.value === 'NON_FACTORED_BILL_OUT'
      );
    } else if (props.type === 'broker') {
      const excludedValues = [
        'NON_FACTORED_PAYMENT_FORWARD',
        'SELF_FINANCE_LEDGER_DEPOSIT',
        'SELF_FINANCE_RECEIVABLES',
        'SELF_FINANCE_STRIPE_DEPOSIT',
      ];
      allowedOptions = fundingRequestType.filter(
        (option) =>
          option.value !== 'STD_CARRIER' &&
          !excludedValues.includes(option.value)
      );
    } else {
      allowedOptions = fundingRequestType;
    }

    // If the current value is not in allowedOptions, add it as disabled so it shows in the field
    const currentValue = props.value;

    if (currentValue && !allowedOptions.some((option) => option.value === currentValue)) {
      const currentOption = fundingRequestType.find(
        (option) => option.value === currentValue
      );

      if (currentOption) {
        allowedOptions = [{ ...currentOption, disabled: true }, ...allowedOptions];
      }
    }


    return allowedOptions;
  }, [props.type, props.value]);



  return (
    <Select
      {...props}
      value={props.value}
      onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
        e.preventDefault();
        switch (e.target.value) {
          case 'NON_FACTORED_STANDARD':
            props.setFieldValue('nonFactored', true);
            props.setFieldValue('billOutOnly', false);
            props.setFieldValue('self_finance_requested', false);
            props.setFieldValue('selfFinanceRequested', false);
            break;
          case 'NON_FACTORED_BILL_OUT':
            props.setFieldValue('nonFactored', true);
            props.setFieldValue('billOutOnly', true);
            props.setFieldValue('self_finance_requested', false);
            props.setFieldValue('selfFinanceRequested', false);
            break;
          case 'SELF_FINANCE_NO_INVOICE':
            props.setFieldValue('nonFactored', false);
            props.setFieldValue('billOutOnly', false);
            props.setFieldValue('self_finance_requested', true);
            props.setFieldValue('selfFinanceRequested', true);
            break;
          case 'SELF_FINANCE_WITH_INVOICE':
            props.setFieldValue('nonFactored', false);
            props.setFieldValue('billOutOnly', false);
            props.setFieldValue('self_finance_requested', true);
            props.setFieldValue('selfFinanceRequested', true);
            break;
          default:
            props.setFieldValue('nonFactored', false);
            props.setFieldValue('billOutOnly', false);
            props.setFieldValue('self_finance_requested', false);
            props.setFieldValue('selfFinanceRequested', false);
            break;
        }
        props.setFieldValue(props.name || 'contact_type', e.target.value);
      }}
      selections={filteredOptions}
      hiddenValues={[]}
    />
  );
};
export default FundingRequestTypeSelect;
